
<v-hover v-slot="{ hover }" open-delay="200">
    <v-flex xs12>
        <v-card
            flat
            rounded
            style="border-style: solid; border-width: 1px; border-color: lightgray; margin: 4px"
        >

            <v-card-title primary-title>
                <crm-reminder-entry-menu
                    v-show="hover"
                    v-model="menuOpen"
                    :reminder="reminder"
                />

                <div style="width: 100%">

                <menu-site-card
                    :sites="reminder.incident.sites"
                    :time="reminder.time"
                    :customer="null"
                    icon="fas fa-bell"
                    @expand="onExpand"
                />

                <div class="crm-reminder-primary-info">
                    <div class="w-100">
                        <div>{{ reminder.subject }}</div>
                        <div style="margin-top: -6px; white-space: pre-line">{{ reminder.description }}</div>
                    </div>

                    <div v-if="reminder.partner">
                        <div><p >{{ reminder.partner.name }}</p></div>
                        <div class="space-between" style="margin-top: -5px">
                            <div><p>{{ reminder.partner.phone }}</p></div>
                            <div><p>{{ reminder.partner.email }}</p></div>
                        </div>
                    </div>
                </div>
                </div>
            </v-card-title>
        </v-card>
    </v-flex>
</v-hover>
